export enum CATEGORIES {
  TopRated = 'top_rated',
  Upcoming = 'upcoming',
}
